var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-65 9 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M217.957 381.785L216.235 322.407C216.235 322.407 288.48 328.152 303.936 320.134C303.936 320.134 322.822 222.939 300.296 169.114L299.84 167.018L147.382 149.206L137.897 235.524C132.762 220.397 91.3175 204.298 80.2372 225.962C56.2276 272.906 142.075 304.515 142.075 304.515L133.359 382.5",
    fill: "#5E93D1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    opacity: 0.400274,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.235 322.406L167.521 311.974L216.001 344.684L216.235 322.406Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M256.421 225.373L273.254 266.478L253.08 266.735L256.421 225.373Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.227 237.055C238.23 242.59 234.549 247.887 229.006 248.889C223.465 249.891 218.159 246.214 217.158 240.68C216.154 235.145 219.834 229.846 225.377 228.845C230.92 227.845 236.224 231.519 237.227 237.055Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.173 237.055C291.177 242.59 287.495 247.887 281.952 248.889C276.411 249.891 271.106 246.214 270.104 240.68C269.101 235.145 272.781 229.846 278.324 228.845C283.866 227.845 289.17 231.519 290.173 237.055Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.489 278.374C235.489 278.374 242.54 289.794 256.507 288.826L235.489 278.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 14",
    d: "M235.489 278.374C235.489 278.374 242.54 289.794 256.507 288.826",
    stroke: "#252535",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.818 236.444C127.434 224.655 115.044 219.661 107.529 217.587L108.963 187.837L180.578 175.365C175.643 208.554 156.474 226.661 138.818 236.444Z",
    fill: "#EACB47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.523 180.72C298.071 174.59 256.019 172.691 205.468 176.579C193.711 177.483 182.438 178.622 172.015 179.943C137.557 184.265 112.204 190.413 108.077 195.82C103.5 128.259 144.929 88.0224 199.172 84.279C234.758 81.8196 267.03 95.6899 286.348 124.588C296.233 139.399 302.738 158.17 304.523 180.72Z",
    fill: "#393954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.338 182.058H305.32C305.251 181.588 304.974 181.136 304.523 180.72C298.071 174.589 256.019 172.691 205.468 176.579C193.709 177.483 182.438 178.622 172.015 179.942C186.842 165.873 213.964 143.63 245.96 133.648C259.642 129.38 273.517 126.269 286.348 124.588C317.494 120.464 342.483 124.696 343.733 140.845C345.344 161.858 310.714 179.454 305.338 182.058Z",
    fill: "#161629"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.f507b9f1.svg";
export { ForwardRef as ReactComponent };